import { render, staticRenderFns } from "./SolutionType.vue?vue&type=template&id=77f06e88&scoped=true&"
import script from "./SolutionType.vue?vue&type=script&lang=js&"
export * from "./SolutionType.vue?vue&type=script&lang=js&"
import style0 from "./SolutionType.vue?vue&type=style&index=0&id=77f06e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f06e88",
  null
  
)

export default component.exports